export default __webpack_public_path__ + "static/media/user-add.d8473955.svg";